import Shipment from '@/models/shipment'
import Coords from '@/models/coordinates'

export default {
  namespaced: true,
  state: {
    schema: Shipment.schema(),
    count: 0
  },
  actions: {
    async list ({ dispatch, state }, params) {
      return dispatch('list', { modelClass: Shipment, params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async coordinates ({ dispatch, state }, params) {
      return dispatch('list', { modelClass: Coords, params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async retrieve ({ dispatch, state }, id) {
      return dispatch('retrieve', { modelClass: Shipment, id: id }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async patch ({ dispatch, state }, data) {
      return dispatch('partialUpdate', {modelClass: Shipment, id: data.id, data: data}, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async export ({ dispatch, state }, params) {
      return dispatch(
        'download',
        {
          method: 'get',
          params: params,
          url: `shipments/export`
        }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async attachment ({ dispatch, state }, data) {
      return dispatch(
        'save', {
          action: 'attachment',
          modelClass: Shipment,
          id: data.id,
          data: {
            'schema_form': data.schema_form,
            'sf_data': data.sf_data
          }
        }, { root: true })
        .then(response => { state.object = response })
        .catch(error => { throw error })
    },
    async lastEvents ({ dispatch, state }, id) {
      return dispatch('request', { url: `shipments/${id}/alert_events`, method: 'get' }, { root: true })
        .then(response => {
          state.count = response.count
          return response.data
        })
        .catch(error => { throw error })
    },
    async hide ({ dispatch, state }, id) {
      return dispatch('request', { url: `shipments/${id}/hide`, method: 'post' }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    },
    async show ({ dispatch, state }, id) {
      return dispatch('request', { url: `shipments/${id}/show`, method: 'post' }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    },
    async hideEvent ({ dispatch, state }, id) {
      return dispatch('request', { url: `events/${id}/hide`, method: 'post' }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    },
    async unhideEvent ({ dispatch, state }, id) {
      return dispatch('request', { url: `events/${id}/unhide`, method: 'post' }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    },
    async hideAllEvents ({ dispatch, state }, id) {
      return dispatch('request', { url: `shipments/${id}/hide_all_events`, method: 'post' }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    },
    async unhideAllEvents ({ dispatch, state }, id) {
      return dispatch('request', { url: `shipments/${id}/unhide_all_events`, method: 'post' }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/shipment.js